import { render, staticRenderFns } from "./DistributeSpacingVIcon.vue?vue&type=template&id=59dc62a4&"
import script from "./DistributeSpacingVIcon.vue?vue&type=script&lang=js&"
export * from "./DistributeSpacingVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports